/**
 * @file Modal names.
 */

export const CREATE_ACCOUNT_IDENTITY_MODAL = 'modal/CREATE_ACCOUNT_IDENTITY';
export const UPDATE_ACCOUNT_IDENTITY_MODAL = 'modal/UPDATE_ACCOUNT_IDENTITY';
export const PURCHASE_IDENTITY_NAV_MODAL = 'modal/PURCHASE_IDENTITY_NAV';
export const DISCOVER_IDENTITY_NAV_MODAL = 'modal/DISCOVER_IDENTITY_NAV';
export const DISCOVER_IDENTITY_WARNING_MODAL =
  'modal/DISCOVER_IDENTITY_WARNING';
export const CREATE_ALBUM_FOLDER_MODAL = 'modal/CREATE_ALBUM_FOLDER';
export const UPDATE_ALBUM_FOLDER_MODAL = 'modal/UPDATE_ALBUM_FOLDER';
export const SUPPORT_MODAL = 'modal/SUPPORT_MODAL';
export const PHOTO_MOVE_MODAL = 'modal/PHOTO_MOVE_MODAL';
export const CONFIRM_MODAL = 'modal/CONFIRM';
export const CONFIRM_MODAL_WITH_PASSWORD = 'modal/CONFIRM_WITH_PASSWORD';
export const SUBSCRIPTION_DESC_MODAL = 'modal/SUBSCRIPTION_DESC';
export const WEB_GALLERY_CHECKOUT = 'modal/WEB_GALLERY_CHECKOUT';
export const ALBUM_FOLDER_PHOTOS_UPLOAD_MODE =
  'modal/ALBUM_FOLDER_PHOTOS_UPLOAD_MODE';
export const ALBUM_FOLDER_PHOTOS_ASSIGN_MODAL =
  'modal/ALBUM_FOLDER_PHOTOS_ASSIGN_MODAL';
export const UPDATE_SELECTED_IDENTITY_MODAL = 'modal/UPDATE_SELECTED_IDENTITY';
export const PHOTO_GROUP_MODAL = 'modal/PHOTO_GROUP';
export const FLUSH_COMPARISON_MODAL = 'modal/FLUSH_COMPARISON';
export const MONITORING_NOTES_MODAL = 'modal/MONITORING_NOTES';
export const MONITORING_COMMANDERING_MODAL = 'modal/MONITORING_COMMANDERING';
export const ALBUM_WARNINGS_MODAL = 'modal/ALBUM_WARNINGS_MODAL';
export const WEB_GALLERY_UPSELL_MODAL = 'modal/WEB_GALLERY_UPSELL';
export const IDENTITY_ADMIN_INFO_MODAL = 'modal/IDENTITY_ADMIN_INFO';
export const PHONE_AUTH_MODAL = 'modal/PHONE_AUTH';
export const WEB_GALLERY_AD_WIDGET_MODAL = 'modal/WEB_GALLERY_AD_WIDGET';
export const DISCOVER_IDENTITY_SELECTED_ALBUMS =
  'modal/DISCOVER_IDENTITY_SELECTED_ALBUMS';
export const DISCOVER_REQUEST_MODAL = 'modal/DISCOVER_REQUEST';
export const COMMAND_IDENTITY_REPORT_MODAL =
  'modal/COMMAND_IDENTITY_REPORT_MODAL';
export const UNIFORM_TAG_FORM_MODAL = 'modal/UNIFORM_TAG_FORM_MODAL';
export const GRADE_TAG_FORM_MODAL = 'modal/GRADE_TAG_FORM_MODAL';
export const PHOTO_MODAL = 'modal/PHOTO_MODAL';
export const PHOTO_ALBUM_FOLDER_TAGS = 'modal/PHOTO_ALBUM_FOLDER_TAGS';
export const PURCHASE_PPD_TYPE_MODAL = 'modal/PURCHASE_PPD_TYPE_MODAL';
export const PURCHASE_PPD_PURCHASE_PACKAGE =
  'modal/PURCHASE_PPD_PURCHASE_PACKAGE';
export const PURCHASE_PPD_PURCHASE_INDIVIDUAL_PRINT =
  'modal/PURCHASE_PPD_PURCHASE_INDIVIDUAL_PRINT';
export const PRINT_PACKAGE_FORM_MODAL = 'modal/PRINT_PACKAGE_FORM';
export const PHOTO_PRICING_FORM_MODAL = 'modal/PHOTO_PRICING_FORM';
export const PRINT_PACKAGE_ALBUMS_MODAL = 'modal/PRINT_PACKAGE_ALBUMS';
export const PRINT_PACKAGE_ALBUM_FOLDERS_MODAL =
  'modal/PRINT_PACKAGE_ALBUM_FOLDERS';
export const PHOTO_PRICING_ALBUMS_MODAL = 'modal/PHOTO_PRICING_ALBUMS';
export const PHOTO_PRICING_ALBUM_FOLDERS_MODAL =
  'modal/PHOTO_PRICING_ALBUM_FOLDERS';
export const WEDDING_GALLERY_UPSELL_MODAL = 'modal/WEDDING_GALLERY_UPSELL';
export const TAG_PRICING_MODAL = 'modal/TAG_PRICING';
export const SAVE_SEARCH_MODAL = 'modal/SAVE_SEARCH';
export const ALBUM_SAVE_SEARCH_MODAL = 'modal/ALBUM_SAVE_SEARCH';
export const CONTRIBUTORS_ALBUM_FOLDER_MODAL =
  'modal/CONTRIBUTORS/ALBUM_FOLDER';
export const ALBUM_FOLDER_PURCHASE_OPTIONS_INTERSTITIAL_MODAL =
  'modals/ALBUM_FOLDER_PURCHASE_OPTIONS_INTERSTITIAL';
export const INDIVIDUAL_PHOTO_NOTICE_MODAL = 'modals/INDIVIDUAL_PHOTO_NOTICE';
export const DISCOVER_PURCHASE_SELECTION_MODAL =
  'modals/DISCOVER_PURCHASE_SELECTION';
export const TRANSACTION_DETAILS_MODAL = 'modals/TRANSACTION_DETAILS';
export const ORDER_DETAILS_MODAL = 'modals/ORDER_DETAILS';
export const ACCOUNT_UPDATE_PHONE_NUMBER_MODAL =
  'modals/ACCOUNT_UPDATE_PHONE_NUMBER';
export const CUSTOM_PRINT_UPDATE_STATUS = 'modals/CUSTOM_PRINT_UPDATE_STATUS';
export const CUSTOM_PRINT_FORM_MODAL = 'modal/CUSTOM_PRINT_FORM';
export const USER_ADDRESS_MODAL = 'modal/USER_ADDRESS_MODAL';
export const COMMAND_PUB_MATCHING_VOTE_MODAL =
  'modal/COMMAND_PUB_MATCHING_VOTE';
export const UNIFORM_TAG_LEVEL_JERSEY_MODAL = 'modal/UNIFORM_TAG_LEVEL_JERSEY';
export const PHOTO_VIEW_MODAL = 'modal/PHOTO_VIEW_MODAL';
export const CUSTOM_PRINT_DESC_MODAL = 'modal/CUSTOM_PRINT_DESC_MODAL';
export const UPDATE_ROSTER_IDENTITY_MODAL = 'modal/UPDATE_ROSTER_IDENTITY';
export const SELFIE_STATION_CREATE_ROSTER_IDENTITY_MODAL =
  'modal/SELFIE_STATION_CREATE_ROSTER_IDENTITY_MODAL';
export const ALBUM_LEVEL_SELECTION_MODAL = 'modal/ALBUM_LEVEL_SELECTION';
export const SELECT_CUSTOM_COVER_PHOTO_MODAL =
  'modal/SELECT_CUSTOM_COVER_PHOTO_MODAL';
export const WALDOGRAM_NULL_STATE_MODAL = 'modal/WALDOGRAM_NULL_STATE_MODAL';
export const WEB_GALLERY_COLLAGE_UPSELL_MODAL =
  'modal/WEB_GALLERY_COLLAGE_UPSELL_MODAL';
export const NUM_REC_COMPARISON_MODAL = 'modal/NUM_REC_COMPARISON_MODAL';
export const MANUAL_MATCH_COMPARISON_MODAL =
  'modal/MANUAL_MATCH_COMPARISON_MODAL';
export const PPD_PURCHASE_PURCHASE_OPTIONS =
  'modal/PPD_PURCHASE_PURCHASE_OPTIONS';
export const MANUAL_MATCH_PUB_MODAL = 'modal/MANUAL_MATCH_PUB_MODAL';
export const ALERT_MODAL = 'modal/ALERT_MODAL';
export const CONTRIBUTOR_PERMISSIONS_MODAL =
  'modal/CONTRIBUTOR_PERMISSIONS_MODAL';
export const ALBUM_INFO_CSS_MODAL = 'modal/ALBUM_INFO_CSS_MODAL';
export const MANUAL_MATCH_FACEBOX_VOTE_MODAL =
  'modal/MANUAL_MATCH_FACEBOX_VOTE_MODAL';
export const ALBUM_FOLDER_TAGS_ASSIGN_MODAL =
  'modal/ALBUM_FOLDER_TAGS_ASSIGN_MODAL';
export const UNIFORM_TAG_LEVEL_TEAM_MODAL = 'modal/UNIFORM_TAG_LEVEL_TEAM';
export const CONTRIBUTOR_SHARE_MODAL = 'modal/CONTRIBUTOR_SHARE';
export const ALBUM_FOLDER_SHUTTERBUG_TAG_TEMPLATES_MODAL =
  'modal/ALBUM_FOLDER_SHUTTERBUG_TAG_TEMPLATES_MODAL';
export const REPORT_PHOTO_MODAL = 'modal/REPORT_PHOTO_MODAL';
export const USERPAGE_PRO_ONBOARDING_MODAL =
  'modal/USERPAGE_PRO_ONBOARDING_MODAL';
export const SHARE_BLOCK_MODAL = 'modal/SHARE_BLOCK_MODAL';
export const FEATURE_REQUEST_MODAL = 'modal/FEATURE_REQUEST_MODAL';
